import { Autocomplete, TextField, Chip, alpha, useTheme } from "@mui/material";
import { ACCENT } from "./accent";

/**
 * Controlled free-form tag input: chips + an autocomplete suggesting tags the
 * user has already used elsewhere. Parent persists via onChange.
 */
const TagEditor = ({ value = [], onChange, suggestions = [], disabled, placeholder = "Add tag…" }) => {
  const theme = useTheme();
  return (
    <Autocomplete
      multiple
      freeSolo
      size="small"
      disabled={disabled}
      options={suggestions.filter((s) => !value.includes(s))}
      value={value}
      onChange={(_, next) => {
        // Normalise: trim, drop blanks, de-dupe.
        const clean = [];
        next.forEach((t) => {
          const v = (t || "").trim();
          if (v && !clean.includes(v)) clean.push(v);
        });
        onChange(clean);
      }}
      renderTags={(tags, getTagProps) =>
        tags.map((tag, i) => (
          <Chip
            {...getTagProps({ index: i })}
            key={tag}
            label={tag}
            size="small"
            sx={{
              backgroundColor: alpha(ACCENT, 0.15),
              color: ACCENT,
              "& .MuiChip-deleteIcon": { color: alpha(ACCENT, 0.7) },
            }}
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={value.length ? "" : placeholder}
          sx={{ "& .MuiOutlinedInput-root": { color: theme.palette.text.primary } }}
        />
      )}
      sx={{ minWidth: 240 }}
    />
  );
};

export default TagEditor;
